import './styles/main.css';
import * as THREE from 'three/webgpu';
import './game-engine/app.js';
import { BushField } from './game-engine/plants';
import JoystickController from 'joystick-controller';

import {
    DynamicCube,
    FixedCube,
    LFixed,
    KinematicRectObjectRotated,
} from './game-objects/simple-game-objects.js';

import { Floor } from './game-objects/floors.js';
import { VehicleObject } from './game-objects/VehicleObject.js';

import { Grass } from './game-world/grass.js';

// get parameters from URL
const params = new URLSearchParams( window.location.search );

const viewport = document.querySelector('game-viewport');
const app = document.querySelector('game-app');

const debug = (import.meta.env.DEV | params.get('debug') === 'true')
    & params.get('debug') !== 'false';

await app.init({
    debug,
});

window.app = app;

if ( debug ) {
    document.querySelector('game-viewport').setAttribute('stats-gl', '');
}

app.setInputsMap([
    { name: 'forward', keys: ['ArrowUp', 'KeyW'] },
    { name: 'backward', keys: ['ArrowDown', 'KeyS'] },
    { name: 'left', keys: ['ArrowLeft', 'KeyA'] },
    { name: 'right', keys: ['ArrowRight', 'KeyD'] },
    { name: 'boost', keys: ['ShiftRight'] },
    { name: 'brake', keys: ['ShiftLeft'] }
]);

// Add Joystick controller
const joystick = new JoystickController(
    {
        maxRange: 50,
        level: 10,
        leftToRight: false,
        x:'20%', y: '20%',
        mouseClickButton: "LEFT",
    },
    ({x, y}) => {
        // console.log(x, y);
        if (y > 20) {
            app.inputs.keys.forward = true;
            if (y > 40) {
                app.inputs.keys.boost = true;
            }
        }
        else if (y < -20) {
            app.inputs.keys.backward = true;
            if (y < -40) {
                app.inputs.keys.boost = true;
            }
        }
        else {
            app.inputs.keys.forward = false;
            app.inputs.keys.backward = false;
            app.inputs.keys.boost = false;
        }

        if (x > 10) {
            app.inputs.keys.right = true;
        }
        else if (x < -10) {
            app.inputs.keys.left = true;
        }
        else {
            app.inputs.keys.right = false;
            app.inputs.keys.left = false;
        }
    }
);

if (debug) {
    app.debugPane.addFolder({
        title: '🎮 Inputs',
        expanded: false,
    });
}

if (debug) {
    const viewportFolder = app.debugPane.addFolder({
        title: '👀 Viewport',
        expanded: false,
    });
    viewportFolder.addBlade({
        view: 'list',
        label: 'Camera',
        options: [
            { text: 'Game', value: 'game' },
            { text: 'Orbital', value: 'orbit' },
        ],
        value: 'game',
    }).on('change', (event) => {
        if (event.value === 'game') {
            removeOrbitControls();
            addViewportControls();
        } else if (event.value === 'orbit') {
            removeViewportControls();
            addOrbitControls();
        }
    });
}

// Ajout d'un champ de buissons

const bushFieldParams = {
    size: new THREE.Vector2(30, 30),
};

let bushField = null;

const createBushField = () => {
    bushField = new BushField(bushFieldParams.size.x, bushFieldParams.size.y, {
        branchCount: 60,
        radius: 0.7,
        seed: 'toto',
    });
    app.scene.add(bushField);
}

createBushField();


if ( debug ) {
    const bushFieldFolder = app.debugPane.addFolder({
        title: '🌲 BushField',
        expanded: false,
    });
    bushFieldFolder.addBinding(bushFieldParams, 'size', {
        min: 1,
        max: 100,
        step: 1
    }).on('change', (event) => {
        if (event.last) {
            bushField.dispose();
            app.scene.remove(bushField);
            createBushField();
        }
    });
}

// Add floor

const floor = new Floor();
app.addGameObject(floor);


// Add game objects in the scene

const cube1 = new DynamicCube();
app.addGameObject(cube1);
cube1.setPosition( 0, new THREE.Vector3( -1, 3, 0 ) );

const cube2 = new DynamicCube();
app.addGameObject(cube2);
cube2.setPosition( 0, new THREE.Vector3( 1, 3, 0 ) );
cube2.setRotationFromEuler( 0, new THREE.Euler( Math.PI / 3, 0, 0 ) );

const cube3 = new FixedCube();
app.addGameObject(cube3);
cube3.setPosition( 0, new THREE.Vector3( 4, 0.5, 0 ) );
cube3.setRotationFromEuler( 0, new THREE.Euler( 0, Math.PI / 3, 0 ) );

const cube4 = new LFixed();
app.addGameObject(cube4);
cube4.setPosition( 0, new THREE.Vector3( -4, 0.5, 0 ) );
cube4.setRotationFromEuler( 0, new THREE.Euler( 0, 0, 0 ) );

const rectRotated = new KinematicRectObjectRotated();
app.addGameObject( rectRotated );
rectRotated.setPosition( 0, new THREE.Vector3(0, 0.5, 4));
rectRotated.setAngVel( 0, new THREE.Vector3(0, 1, 0));

// Add grass

const grassParams = {
    chunkSize: 20,
    details: 160,
    centerPosRandomness: 0.7,
    bladeWidth: 0.15,
    bladeHeight: 0.56,
    bladeHeightRandomness: 0.76,
    bladeColor: new THREE.Color(0.5,0.7,0),
}

let grass = new Grass({
    chunkSize: grassParams.chunkSize,
    details: grassParams.details,
    centerPosRandomness: grassParams.centerPosRandomness,
    bladeWidth: grassParams.bladeWidth,
    bladeHeight: grassParams.bladeHeight,
    bladeHeightRandomness: grassParams.bladeHeightRandomness,
    bladeColor: grassParams.bladeColor,
});
app.scene.add(grass);
grass.position.set(2, 0, 3);

// BUG : Not rendering blade color without this line of code !!!!
viewport.renderer.debug.getShaderAsync( app.scene, viewport.camera, grass)
    .then( ( event ) => {
        // console.log( event.vertexShader );
        // console.log( event.fragmentShader );
    });

if (debug) {
    viewport.renderer.debug.getShaderAsync( app.scene, viewport.camera, grass)
        .then( ( event ) => {
            console.log( event.vertexShader );
            console.log( event.fragmentShader );
        });
    
    // https://emojipedia.org/herb#emoji
    const grassFolder = app.debugPane.addFolder({
        title: '🌿 Grass',
        expanded: false,
    });

    grassFolder.addBinding(grassParams, 'chunkSize', {
        min: 1, max: 100, step: 1
    }).on('change', (event) => {
        if (event.last) {
            grass.dispose(); app.scene.remove(grass);
            grass = new Grass(grassParams); app.scene.add(grass);
        }
    });

    grassFolder.addBinding(grassParams, 'details', {
        min: 10, max: 1000, step: 10
    }).on('change', (event) => {
        if (event.last) {
            grass.dispose(); app.scene.remove(grass);
            grass = new Grass(grassParams); app.scene.add(grass);
        }
    });

    grassFolder.addBinding(grassParams, 'centerPosRandomness', {
        min: 0.0, max: 1.0, step: 0.01
    }).on('change', (event) => {
        if (event.last) {
            grass.dispose(); app.scene.remove(grass);
            grass = new Grass(grassParams); app.scene.add(grass);
        }
    });

    grassFolder.addBinding(grassParams, 'bladeWidth', {
        min: 0.1, max: 1.0, step: 0.01
    }).on('change', (event) => {
        if (event.last) {
            grass.dispose(); app.scene.remove(grass);
            grass = new Grass(grassParams); app.scene.add(grass);
        }
    });

    grassFolder.addBinding(grassParams, 'bladeHeight', {
        min: 0.1, max: 1.0, step: 0.01
    }).on('change', (event) => {
        if (event.last) {
            grass.dispose(); app.scene.remove(grass);
            grass = new Grass(grassParams); app.scene.add(grass);
        }
    });

    grassFolder.addBinding(grassParams, 'bladeHeightRandomness', {
        min: 0.0, max: 1.0, step: 0.01
    }).on('change', (event) => {
        if (event.last) {
            grass.dispose(); app.scene.remove(grass);
            grass = new Grass(grassParams); app.scene.add(grass);
        }
    });

    grassFolder.addBinding(grassParams, 'bladeColor', {
        color: { type: 'float'}
    }).on('change', (event) => {
        console.log( event.value );
        grass.bladeColor = event.value;
    })
}

// Add Vehicle in the scene

const vehicle1 = new VehicleObject({
    length: 3,
    width: 1.5,
    height: 1.0,
    wheelRadius: 0.5,
});
app.addGameObject(vehicle1);
vehicle1.setPosition( 0, new THREE.Vector3( 0, 1.20, 0 ) );

if (debug) {
    const vehicleFolder = app.debugPane.addFolder({
        title: '🚗 Vehicle',
        expanded: false,
    });

    vehicleFolder.addBinding(vehicle1, 'maxEngineForce', {
        min: 0.0,
        max: 1000.0,
        // label: 'max engine force',
    });

    const wheelsFolder = vehicleFolder.addFolder({
        title: '🛞 Wheels',
        expanded: true,
    });

    wheelsFolder.addBinding(vehicle1.vehicleParams, 'wheelRadius', {
        min: 0.1,
        max: 1.0,
        label: 'radius',
    }).on('change', (event) => {
        if (event.last) {
            vehicle1.apply();

        }
    });

    wheelsFolder.addBinding(vehicle1.vehicleParams, 'suspensionRestLength', {
        min: 0.0,
        max: 0.5,
        label: 'rest length',
    }).on('change', (event) => {
        if (event.last) {
            vehicle1.apply();
        }
    });

    const hydraulicsFolder = vehicleFolder.addFolder({
        title: '🚜 Hydraulics',
        expanded: true,
    });
}



// Add Orbital Controls (for debugging)

import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { ViewportControls } from './game-engine/ViewportControls.js';

viewport.camera.position.set(6, 5, 8);

let viewportControl = null;

function addOrbitControls() {
    viewportControl = new OrbitControls(viewport.camera, viewport.canvas);
    viewportControl.enableDamping = true;
    // console.log(viewportControl instanceof ViewportControls);
}

function removeOrbitControls() {
    // console.log('Removing orbit controls');
    viewportControl.dispose();
    viewportControl = null;
}

function addViewportControls() {
    viewportControl = new ViewportControls(viewport.camera, viewport.canvas);
    // console.log(viewportControl instanceof ViewportControls);
    viewportControl.follow(vehicle1.chassisMesh);
}

function removeViewportControls() {
    // console.log('Removing viewport controls');
    viewportControl.dispose();
    viewportControl = null;
}

addViewportControls();

viewport.renderUpdate = () => {
    if (viewportControl) {
        viewportControl.update();
    }

    grass.setTargetPosition( vehicle1.getPosition() );
}


app.updatePhysics = () => {

    // console.log(engine.inputs.keys);
    vehicle1.engineForce = (app.inputs.keys.forward ? vehicle1.maxEngineForce : 0.0) - (app.inputs.keys.backward ? vehicle1.maxBackwardEngineForce : 0.0);
    vehicle1.engineForce *= app.inputs.keys.boost ? 3.0 : 1.0;

    if (vehicle1.engineForce === 0.0) {
        vehicle1.brakeForce = 8.0;
    }
    else {
        vehicle1.brakeForce = 0.0;
    }

    if (app.inputs.keys.forward && app.inputs.keys.backward) {
        vehicle1.engineForce = 0.0;
        vehicle1.brakeForce = 15.0;
    }

    vehicle1.steering = (app.inputs.keys.left ? 0.5 : 0.0) - (app.inputs.keys.right ? 0.5 : 0.0);

};

console.log('Main initialized!');
